import { useContext } from 'react';
import { AuthContext, type AccessLevel } from '@/contexts/auth-context';
import type { TierName } from '@/lib/tierLimits';

// Re-export types for consumers
export type { TierName, AccessLevel };

/**
 * Hook to access authentication state and methods
 *
 * Must be used within an AuthProvider
 */
export function useAuth() {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}
